import { message as $message } from 'antd'
import { afterSaleStatisticsAction, shopExist } from '@/services/afterSale'

const AfterSalesModel = {
    namespace: 'afterSales',
    state: {
        afterSalesCounts: [],
        hasTaoxiShop: undefined,
        iframeAfterSalesPath: ''
    },
    effects: {
        *query({ payload }, { call, put }) {
            const values = {
                ...(payload || {})
            }
            try {
                const res = yield call(afterSaleStatisticsAction, values)

                if (res.success) {
                    if (res.data) {
                        yield put({
                            type: 'update',
                            payload: { afterSalesCounts: res.data }
                        })
                        return res.data
                    }
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('afterSaleStatisticsAction error', e)
            }
        },

        *queryHasTaoxiShop({ payload }, { call, put, select }) {
            const values = {
                ...(payload || {})
            }
            try {
                const hasTaoxiShop = yield select(state => state.afterSales?.hasTaoxiShop)
                // 为了避免接口重复调用
                if (hasTaoxiShop === undefined) {
                    const res = yield call(shopExist, values)
                    if (res.success) {
                        yield put({
                            type: 'update',
                            payload: { hasTaoxiShop: !!res.data }
                        })
                        return res.data
                    } else {
                        $message.error(res.message)
                    }
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
        *changeTowerRouter({ payload }, { put }) {
            yield put({
                type: 'update',
                payload: { iframeAfterSalesPath: payload?.pathname }
            })
        }
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        }
    }
}

export default AfterSalesModel
